import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { Divider } from '@src/components/Divider';
import api from '@src/util/api';
import { idify } from '@src/util/idify';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import { trackEvent } from '@src/metrics';
import { setErrorFlashMessage } from '@src/redux/actions/flashMessages';
import { useCustomerForBillingHistoryQuery } from '@src/graphql/generated';
import './styles.scss';

const BillingHistory = ({ setErrorFlashMessage }) => {
  const [billingHistory, setBillingHistory] = useState([]);

  const { loading, error, data } = useCustomerForBillingHistoryQuery({
    onError: () => setErrorFlashMessage(),
  });

  useEffect(() => {
    api('/api/receipts').then(data => {
      setBillingHistory(data.receipts);
    });
  }, []);

  if (!billingHistory.length || loading || error) {
    return null;
  }

  const customerId = data.customer.id;

  return (
    <div className="billing">
      <Divider
        border="top"
        text="Here is a list of receipts based on the payments made using a credit card. Feel free to contact our support if you have any questions regarding the payments."
        title="Billing history"
      />

      <div className="billing__list">
        {billingHistory.map(receipt => (
          <div className="billing__record" key={idify(receipt)}>
            <div className="billing__date">{moment(parseInt(receipt.timestamp)).format('MMMM YYYY')}</div>
            <div className="billing__info-right">
              <div className="billing__amount">
                {receipt.amount}
                {receipt.amountSymbol}
              </div>
              <a
                className="billing__pdf"
                href={receipt.invoiceUrl}
                onClick={() =>
                  trackEvent({
                    context: MetricContext.BILLING,
                    interaction: MetricAction.VIEW_RECEIPT,
                    payload: {
                      Customer: customerId,
                      Receipt: idify(receipt),
                    },
                  })
                }
                target="blank"
              >
                PDF
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

BillingHistory.propTypes = {
  setErrorFlashMessage: PropTypes.func.isRequired,
};

export default connect(null, {
  setErrorFlashMessage,
})(BillingHistory);
